import { useFlags } from "src/components/Providers/FeatureFlagProvider";
import * as GQL from "src/types/graphql";
import { useFormTemplateContext } from "../formTemplateContext";
import * as Content from "./index";

export const ContentTab: React.FC = () => {
  const { formTemplate } = useFormTemplateContext();

  const flags = useFlags(["live-edit-v2"]);

  if (!flags["live-edit-v2"].enabled) {
    switch (formTemplate.mode) {
      case GQL.form_template_mode_enum.Published:
        return <Content.V1.ContentTab />;
      default:
        return <Content.V2.ContentTab />;
    }
  }

  switch (formTemplate.schema_version) {
    case "1.0.0":
      return <Content.V1.ContentTab />;
    case "2.0.0":
      return <Content.V2.ContentTab />;
    case "3.0.0":
    default:
      return <Content.V3.ContentTab />;
  }
};
